// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__131jC","clickedWithMouse":"MenuLabel_clickedWithMouse__LB-nx","isOpen":"MenuLabel_isOpen__11Gnw"};